"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Date
 */
exports.date = {
    /**
     * RFC3339
     * @since 1.0.0
     * @version 1.0.0
     */
    RFC3339: new RegExp('^(\\d{4}-\\d{2}-\\d{2})((T(\\d{2}:\\d{2}:\\d{2}(?:\\.\\d+)?))(Z|[+-]([01]?[0-9]|2[0-3]):[0-5][0-9])?)?$'),
    /**
     * String
     * @since 1.0.0
     * @version 1.0.0
     */
    string: new RegExp('^(((0[1-9]|[12]\\d|3[01])\\/(0[13578]|1[02])\\/((19|[2-9]\\d)\\d{2}))|((0[1-9]|[12]\\d|30)\\/(0[13456789]|1[012])\\/((19|[2-9]\\d)\\d{2}))|((0[1-9]|1\\d|2[0-8])\\/02\\/((19|[2-9]\\d)\\d{2}))|(29\\/02\\/((1[6-9]|[2-9]\\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$'),
};
/**
 * App Identifier
 * Ex : com.zhortech.appName
 */
exports.appId = new RegExp('^(\\w+)\\.(\\w+)\\.(\\w+)$');
exports.default = {
    date: exports.date,
    appId: exports.appId,
};
//# sourceMappingURL=utils.js.map